function getCommission({ price }: { price: number }) {
	// after confirmation from sudhanshu sir
	// decided not to calculate pricing based on premium
	return {
		type:
			price > 15800000
				? "a"
				: price > 6500000
					? "p" // percentage
					: price > 5300000
						? "e" // either/or
						: "a", // absolute
		value: price > 50000000 ? 400000 : price > 15800000 ? 300000 : price > 6500000 ? 2 : price > 5300000 ? 2 : 100000,
		...(price > 50000000
			? { min: 400000 }
			: price > 15800000
				? { min: 300000 }
				: price > 5300000 && price <= 6500000
					? { min: 100000 }
					: {}),
		includesGst: true,
	};
}

export default function getFeeParams({ price }: { price: number }) {
	const examplePrice =
		price > 50000000
			? "6 Crore"
			: price > 15800000
				? "3 Crore"
				: price > 6500000
					? "1 Crore" // percentage
					: price > 5300000
						? "65 lakhs" // either/or
						: "40 lakhs";

	const examplePriceAmt =
		price > 50000000
			? 60000000
			: price > 15800000
				? 30000000
				: price > 6500000
					? 10000000
					: price > 5300000
						? 6500000
						: 4000000;
	return {
		commission: getCommission({ price }),
		exampleCommission: getCommission({ price: examplePriceAmt }),
		examplePrice,
	};
}
